import { EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

export  class MySubject extends Subject<any> implements EventEmitter<any> {
  emit(value?: any) {
    super.next(value);
  }
}
